import React from 'react';
import { connect } from "react-redux";
import { TextBox, Button as TextBoxButton } from 'devextreme-react/text-box';
import { ReactComponent as SuccessIcon } from "../../../../_metronic/layout/assets/layout-svg-icons/Success.svg";
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';


class ActionsCalendarSubscriptionState extends React.Component {

  renderStatusIcon = () => {
    return (
      <span className="kt-svg-icon" style={{}}>
        <SuccessIcon />
      </span>
    )
  }
  render() {
    if (!this.props.url) {
      return null;
    }
    return (
      <div >

        <Toolbar style={{ paddingLeft: 30, paddingRight: 30 }} >
          <ToolbarItem
            location='before'
            locateInMenu="never"
            render={this.renderStatusIcon}
          />
          <ToolbarItem
            location="before"
            widget="dxTextBox"
            options={{
              width: 500,
              readOnly: true,
              value: this.props.url
            }}
          />

          <ToolbarItem
            location='before'
            locateInMenu="never"
            widget="dxButton"
            options={{
              icon: "copy",
              hint: 'Copy to Clipboard',
              onClick: (e) => {
                navigator.clipboard.writeText(this.props.url);
              }
            }}
          />
          <ToolbarItem
            location='before'
            locateInMenu="never"
            widget="dxButton"
            visible={this.props.status === 1}
            options={{
              type: "default",
              // stylingMode: "outlined",
              // text: "Download ICS",
              icon: "download",
              hint: 'Download ICS File',
              onClick: (e) => {
                window.location.assign(this.props.url);
              }
            }}
          />
          <ToolbarItem
            location='before'
            locateInMenu="never"
            widget="dxButton"
            visible={this.props.status === 1}
            options={{
              type: "default",
              // stylingMode: "outlined",
              // text: "Sync URL",
              icon: "link",
              hint: 'Sync URL with External Calendar',
              onClick: (e) => {
                window.location.assign("webcal:" + this.props.url);
              }
            }}
          />
          {/* <ToolbarItem
            locateInMenu="auto"
            widget="dxButton"
            visible={this.props.status === 1}
            options={{
              type: "danger",
              stylingMode: "outlined",
              text: "Cancel",
              icon: "clear",
              hint: 'Copy to Clipboard',
              onClick: (e) => {
                navigator.clipboard.writeText(this.props.url);
              }
            }}
          /> */}

        </Toolbar>
      </div>

    )
    return (
      <div className="dx-field">
        <div className="dx-field-label" >
          <span className="kt-svg-icon" style={{ marginRight: 5 }}>
            <SuccessIcon />
          </span>
          Active Subscription URL</div>
        <div className="dx-field-value" style={{ width: "100%", float: "left" }}>
          <TextBox
            readOnly={true}
            value={this.props.url}
          >
            <TextBoxButton
              name="copy"
              location="after"
              options={{
                disabled: false,
                icon: 'copy',
                hint: 'Copy to Clipboard',
                onClick: (e) => {
                  navigator.clipboard.writeText(this.props.url);
                }
              }}
            />
          </TextBox>
        </div>
      </div>
    )
  }
}


export default ActionsCalendarSubscriptionState;